import { render, staticRenderFns } from "./EcommerceProductStats.vue?vue&type=template&id=a94179e8&"
import script from "./EcommerceProductStats.vue?vue&type=script&lang=js&"
export * from "./EcommerceProductStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports